import { render, staticRenderFns } from "./AbaGeral.vue?vue&type=template&id=81e5c974&"
import script from "./AbaGeral.vue?vue&type=script&lang=js&"
export * from "./AbaGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports